import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      redirect: '/home',
      meta: { auth: true },
      component: () => import('./App.vue'),
      children: [
        // Home
        {
          path: 'home',
          name: 'home',
          component: () => import('./views/home/Home.vue')
        },
        // Sections
        {
          path: '/categories/:id/sections',
          name: 'sections',
          component: () => import('./views/sections/Sections.vue')
        },
        // Articles
        {
          path: '/categories/:id/articles',
          name: 'articles',
          component: () => import('./views/articles/Articles.vue')
        },
        {
          path: '/articles/:id',
          name: 'sungle-article',
          component: () => import('./views/articles/RecordForm.vue')
        },
        // News
        {
          path: 'news',
          name: 'news',
          component: () => import('./views/news/News.vue')
        },
        {
          path: 'news/:id',
          name: 'news-single',
          // Carousel
          component: () => import('./views/news/RecordForm.vue')
        },
        {
          path: 'carousel',
          name: 'carousel',
          component: () => import('./views/carousel/Carousel.vue')
        },
        {
          path: 'authors',
          name: 'authors',
          component: () => import('./views/authors/Authors.vue')
        },
        {
          path: 'translators',
          name: 'translators',
          component: () => import('./views/translators/Translators.vue')
        },
        // Emails
        {
          path: 'emails',
          name: 'emails',
          component: () => import('./views/emails/Emails.vue')
        },
        // Likes
        {
          path: 'likes',
          name: 'likes',
          component: () => import('./views/likes/Likes.vue')
        },
        // Problem Reports
        {
          path: 'problem-reports',
          name: 'problem-reports',
          component: () => import('./views/problems/Problems.vue')
        },
        // Contact Us Messsages
        {
          path: 'contact-us',
          name: 'contact-us',
          component: () => import('./views/contactUs/ContactUs.vue')
        },
        // Admins
        {
          path: 'admins',
          name: 'admins',
          component: () => import('./views/admins/Admins.vue')
        },
        // Pages
        {
          path: 'contents/pages/:page',
          name: 'pages',
          component: () => import('./views/contents/Pages.vue')
        },
        // ExternalWebisteLinks
        {
          path: 'contents/external-website-links',
          name: 'external-website-links',
          component: () => import('./views/externalWebisteLinks/ExternalWebisteLinks.vue')
        },
        // ContactInfo
        {
          path: 'contents/contact-info',
          name: 'contact-info',
          component: () => import('./views/contents/ContactInfo.vue')
        },
        // Settings
        {
          path: 'contents/settings',
          name: 'settings',
          component: () => import('./views/contents/Settings.vue')
        },
      ]
    },

    // guest
    {
      path: '/guest/articles/:id',
      name: 'preview-article',
      component: () => import('./views/articles/Preview.vue'),
    },

    // other routes
    {
      path: '/login',
      name: 'Login',
      meta: { auth: false },
      component: () => import('./views/Login.vue'),
    },
    {
      path: '/403',
      name: 'unauthorized',
      component: () => import('./views/Unauthorized.vue')
    },
    {
      path: '*',
      name: 'Not Found',
      component: () => import('./views/NotFound.vue')
    }
  ]
});

Vue.router = router;
export default router;